import type { FC, ReactNode } from 'react'

import Marquee from '@/components/motion/marquee'
import Star from '@/components/generals/star'

const BACK = ['Numbered runs', 'Repaired for life', 'Made in Portugal', 'Designed in Berlin']
const FRONT = ['SS26 Essentials 04', 'Out now', 'Worldwide shipping', 'Free repairs for life']

/** Two crossed tapes: an outlined one behind, an acid one in front, running in opposite directions. */
const TapeCross: FC = (): ReactNode => {
    return (
        <section aria-label='Studio promises' className='relative z-10 -mt-12 h-44 overflow-hidden md:-mt-16 md:h-60'>
            <div className='absolute left-[-10%] top-1/2 w-[120%] -translate-y-1/2 rotate-[3.5deg] border-y border-line bg-coal py-3'>
                <Marquee speed={36} direction={-1}>
                    {BACK.map(item => (
                        <span key={item} className='flex items-center gap-8 pr-8 font-heading text-[clamp(30px,4.2vw,64px)] uppercase leading-none text-outline'>
                            {item}

                            <span className='size-3 rounded-full bg-bone/30' aria-hidden='true' />
                        </span>
                    ))}
                </Marquee>
            </div>

            <div className='absolute left-[-10%] top-1/2 w-[120%] -translate-y-1/2 -rotate-[2.5deg] bg-acid py-3 text-ink shadow-[0_20px_60px_-20px_rgba(0,0,0,0.8)]'>
                <Marquee speed={64}>
                    {FRONT.map(item => (
                        <span key={item} className='flex items-center gap-8 pr-8 font-heading text-[clamp(30px,4.2vw,64px)] uppercase leading-none'>
                            {item}

                            <Star />
                        </span>
                    ))}
                </Marquee>
            </div>
        </section>
    )
}

export default TapeCross
